/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ReadOnlyFuelCompanySerializer,
    ReadOnlyFuelCompanySerializerFromJSON,
    ReadOnlyFuelCompanySerializerToJSON,
} from '../models';

export interface FuelCompanyListRequest {
    nameIcontains?: string;
    labelIcontains?: string;
}

export interface FuelCompanyReadRequest {
    id: number;
}

/**
 * no description
 */
export class FuelCompanyApi extends runtime.BaseAPI {

    /**
     */
    async fuelCompanyListRaw(requestParameters: FuelCompanyListRequest): Promise<runtime.ApiResponse<Array<ReadOnlyFuelCompanySerializer>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.nameIcontains !== undefined) {
            queryParameters['name__icontains'] = requestParameters.nameIcontains;
        }

        if (requestParameters.labelIcontains !== undefined) {
            queryParameters['label__icontains'] = requestParameters.labelIcontains;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/fuel-company/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReadOnlyFuelCompanySerializerFromJSON));
    }

    /**
     */
    async fuelCompanyList(requestParameters: FuelCompanyListRequest): Promise<Array<ReadOnlyFuelCompanySerializer>> {
        const response = await this.fuelCompanyListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async fuelCompanyReadRaw(requestParameters: FuelCompanyReadRequest): Promise<runtime.ApiResponse<ReadOnlyFuelCompanySerializer>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling fuelCompanyRead.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/fuel-company/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyFuelCompanySerializerFromJSON(jsonValue));
    }

    /**
     */
    async fuelCompanyRead(requestParameters: FuelCompanyReadRequest): Promise<ReadOnlyFuelCompanySerializer> {
        const response = await this.fuelCompanyReadRaw(requestParameters);
        return await response.value();
    }

}
